import { Component, ReactNode } from "react";
import { Card, ErrorBoundary as CCKErrorBoundary, PageHeader } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Location } from "react-router-dom";

interface Props {
	children: ReactNode;
	goBack?: () => void;
	location: Location;
}

interface State {
	hasError: boolean;
	error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch() {
		// Reserved for error reporting or side effects (e.g., send to monitoring)
	}

	componentDidUpdate(prevProps: Props) {
		if (this.state.hasError && prevProps.location?.pathname !== this.props.location?.pathname) {
			this.setState({ hasError: false, error: undefined });
		}
	}

	handleGoBack = () => {
		if (window.history.length > 1) {
			window.history.back();
		} else {
			window.location.href = "/view/";
		}
	};

	render() {
		if (this.state.hasError) {
			return (
				<div>
					<PageHeader>
						<PageHeader.Title>
							{intl.formatMessage({ id: "ERROR" })}
						</PageHeader.Title>
					</PageHeader>

					<Card disablePadding>
						<CCKErrorBoundary errorMessage={this.state.error?.message ?? ""} />
					</Card>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
